import React, { Component } from "react";
import { Helmet } from "react-helmet";
import { connect } from "react-redux";
import {
  setLoading,
  showMessage,
  handleAppError,
  clearFormErrors,
  setCurrentRecord,
} from "../../actions";
import axios from "../../axios";
import { GeneralSettingsComponent } from "./components/GeneralSettingsComponent";
import { ITQModal } from "../../libs";
import { Button } from "@material-ui/core";
import { PasswordEntryComponent } from "./components/PasswordEntryComponent";
import { Password } from "../../models";
import {
  TableAcceptIcon,
  TableButtonEditIcon,
  TableModifyInsuranceRequestDateIcon,
  TableRejectIcon,
} from "../../libs/SVGIcons";

class GeneralSettings extends Component {
  state = {
    currentRecord: null,
    //related to passwords managing
    passwordsData: [],
    showPasswordsModal: false,
    showPasswordEntryModal: false,
    currentPasswordRecord: new Password(),
    currentPasswordRecordIndex: 0,
    isUpdate: false,
  };
  constructor() {
    super();
  }
  componentDidMount() {
    this.getOptionsData().then(() => {
      if (
        this.props.user.permissions["passwords"] &&
        this.props.user.permissions["passwords"]["view-all"]
      ) {
        this.getPasswords();
      }
    });
  }
  async getOptionsData() {
    const { handleAppError, setLoading } = this.props;
    try {
      setLoading(true);
      const response = await axios.get("/options/general");
      const rawOptions = response.data.data;
      const companyIPSetting = JSON.parse(rawOptions.find(o => o.key === 'company_ip').value);
      const options = {};
      options.enablecompanyip = companyIPSetting.enabled;
      options.companyip = companyIPSetting.ip;
      options.apiautoretriescount = rawOptions.find(o => o.key === 'apiautoretriescount')?.value || 0;
      options.trafficnetpercentage = rawOptions.find(o => o.key === 'trafficnetpercentage')?.value || 0;
      options.systemautomode = JSON.parse(rawOptions.find(o => o.key === 'system_mode_auto')?.value || 'false');
      await this.setState({
        currentRecord: options,
      });
      setLoading(false);
    } catch (error) {
      handleAppError(error);
    }
  }
  async getPasswords() {
    const { handleAppError, setLoading } = this.props;
    try {
      setLoading(true);
      const response = await axios.get("passwords");
      await this.setState({
        passwordsData: response.data.data,
      });
      setLoading(false);
    } catch (error) {
      handleAppError(error);
    }
  }
  async updatePasswords() {
    const { handleAppError, setLoading, showMessage } = this.props;
    const { lang } = this.props.user;
    const { passwordsData } = this.state;
    try {
      setLoading(true);
      await axios.post("passwords", {
        passes: passwordsData,
      });
      setLoading(false);
    } catch (error) {
      handleAppError(error);
    }
  }
  async addPassword(passwordRecord) {
    const { handleAppError, showMessage } = this.props;
    const { lang } = this.props.user;
    try {
      const passwordsDataCopy = [...this.state.passwordsData];
      const found = passwordsDataCopy.find(
        (passwordItem) => passwordItem.title == passwordRecord.title
      );
      if (!found) {
        passwordsDataCopy.push(passwordRecord);
        await this.setState({
          passwordsData: passwordsDataCopy,
          currentPasswordRecord: new Password(),
          isUpdate: false,
        });
        await this.setState({ showPasswordEntryModal: false });
        await this.updatePasswords();
        showMessage({
          type: "success",
          title: window.sys_app_translate("Successful Operation!", lang),
          message: window.sys_app_translate(
            "Password successfully added!",
            lang
          ),
        });
      } else {
        showMessage({
          type: "danger",
          title: window.sys_app_translate("Record Exists!", lang),
          message: window.sys_app_translate("Record already exists!", lang),
        });
      }
    } catch (error) {
      handleAppError(error);
    }
  }
  async updatePassword(index, passwordRecord) {
    const { handleAppError, showMessage } = this.props;
    const { lang } = this.props.user;
    try {
      const passwordsDataCopy = [...this.state.passwordsData];
      passwordsDataCopy[index] = passwordRecord;
      await this.setState({
        passwordsData: passwordsDataCopy,
      });
      await this.setState({ showPasswordEntryModal: false });
      await this.updatePasswords();
      showMessage({
        type: "success",
        title: window.sys_app_translate("Successful Operation!", lang),
        message: window.sys_app_translate(
          "Password updated successfully!",
          lang
        ),
      });
    } catch (error) {
      handleAppError(error);
    }
  }
  async deletePassword(index) {
    const { handleAppError, showMessage } = this.props;
    const { lang } = this.props.user;
    try {
      const passwordDataCopy = [...this.state.passwordsData];
      passwordDataCopy.splice(index, 1);
      await this.setState({
        passwordsData: passwordDataCopy,
      });
      await this.updatePasswords();
      showMessage({
        type: "success",
        title: window.sys_app_translate("Successful Operation!", lang),
        message: window.sys_app_translate(
          "Passwords updated successfully!",
          lang
        ),
      });
    } catch (error) {
      handleAppError(error);
    }
  }
  getPasswordsTable() {
    const { passwordsData } = this.state;
    const { lang, permissions } = this.props.user;

    return (
      <table className="table table-hover table-responsive table-sm passwords-table">
        <thead>
          <tr>
            <th>{window.sys_app_translate("Title", lang)}</th>
            <th>{window.sys_app_translate("Username", lang)}</th>
            <th>{window.sys_app_translate("Password", lang)}</th>
            <th>*</th>
          </tr>
        </thead>
        {passwordsData.map((pass, index) => {
          return (
            <tr key={"p" + index}>
              <td>{pass.title}</td>
              <td>{pass.username}</td>
              <td>
                {permissions["passwords"]["modify"] && (
                  <TableButtonEditIcon
                    style={{ height: "1.5rem" }}
                    className="itqan-table-icon"
                    onClick={async () => {
                      await this.setState({
                        currentPasswordRecord: pass,
                        currentPasswordRecordIndex: index,
                      });
                      await this.setState({
                        showPasswordEntryModal: true,
                        isUpdate: true,
                      });
                    }}
                  />
                )}
                {permissions["passwords"]["delete"] && (
                  <TableRejectIcon
                    style={{ height: "2rem" }}
                    className="itqan-table-icon"
                    onClick={() => {
                      this.deletePassword(index);
                    }}
                  />
                )}
              </td>
            </tr>
          );
        })}
      </table>
    );
  }
  getPasswordsModal() {
    const { showPasswordsModal } = this.state,
      { lang } = this.props.user;
    return (
      <ITQModal
        isOpen={showPasswordsModal}
        isCenterd={true}
        cancelButtonText="x"
        cancelButtonClicked={() => {
          this.setState({
            showPasswordsModal: false,
            currentPasswordRecord: new Password(),
          });
        }}
        title={window.sys_app_translate("Passwords", lang)}
        bodyContent={
          <div className="container">
            <div className="row">
              <div className="col-12 d-flex justify-content-end">
                <Button
                  variant="contained"
                  size="small"
                  onClick={() => {
                    this.setState({
                      showPasswordEntryModal: true,
                      currentPasswordRecord: new Password(),
                      isUpdate: false,
                    });
                  }}
                >
                  {window.sys_app_translate("Add Password", lang)}
                </Button>
              </div>
            </div>
            <div className="row">
              <div className="col-12">{this.getPasswordsTable()}</div>
            </div>
          </div>
        }
        size="lg"
      />
    );
  }
  getPasswordEntryModal() {
    const { showPasswordEntryModal, currentPasswordRecord, isUpdate } =
        this.state,
      { lang } = this.props.user;
    return (
      <ITQModal
        isOpen={showPasswordEntryModal}
        isCenterd={true}
        cancelButtonText="x"
        cancelButtonClicked={() => {
          this.setState({
            showPasswordEntryModal: false,
          });
        }}
        title={window.sys_app_translate("Enter New Password", lang)}
        bodyContent={
          <PasswordEntryComponent
            passwordRecord={currentPasswordRecord}
            isUpdate={isUpdate}
            submitRecord={
              isUpdate
                ? this.updatePassword.bind(this)
                : this.addPassword.bind(this)
            }
          />
        }
        size="md"
      />
    );
  }
  async submit(optionsRecord) {
    const { setLoading, handleAppError, showMessage } = this.props;
    const { lang } = this.props.user;
    try {
      setLoading(true);
      const optionsRecordToPost = {
        company_ip: {
          enabled: optionsRecord.enablecompanyip,
          ip: optionsRecord.companyip,
        },
        system_mode_auto: optionsRecord.systemautomode,
        apiautoretriescount: optionsRecord.apiautoretriescount,
        trafficnetpercentage: optionsRecord.trafficnetpercentage,
      };
      await axios.post("options/general/update", {
        options: JSON.stringify(optionsRecordToPost),
      });
      showMessage({
        type: "success",
        title: window.sys_app_translate("Operation Succeeded", lang),
        message: window.sys_app_translate(
          "Options successfully updated!",
          lang
        ),
      });
      setLoading(false);
    } catch (error) {
      handleAppError(error);
    }
  }
  render() {
    const { lang, permissions } = this.props.user;
    const { showMessage, handleAppError, setLoading } = this.props;
    const { currentRecord } = this.state;
    return (
      <>
      
        <Helmet>
          <meta charSet="utf-8" />
          <title>{window.sys_app_translate("General Settings", lang)}</title>
        </Helmet>

        {currentRecord && (
          
          <GeneralSettingsComponent
            permissions={permissions}
            optionsRecord={currentRecord}
            showPasswordsManager={() => {
              this.setState({
                showPasswordsModal: true,
              });
            }}
            submitRecord={this.submit.bind(this)}
            showMessage={showMessage}
            handleAppError={handleAppError}
            setLoading={setLoading}
          />
        )}

        {permissions["passwords"]["view-all"] && this.getPasswordsModal()}
        {(permissions["passwords"]["create"] ||
          permissions["passwords"]["modify"]) &&
          this.getPasswordEntryModal()}
      </>
    );
  }
}

// map state to props
const mapStateToProps = ({ authUser, appReducer }) => {
  const { user } = authUser;
  const { formErrors, currentRecord } = appReducer;
  return { user, formErrors, currentRecord };
};
export default connect(mapStateToProps, {
  setLoading,
  showMessage,
  handleAppError,
  clearFormErrors,
  setCurrentRecord,
})(GeneralSettings);
